export const NAV_LINKS = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Capabilities", path: "/capabilities" },
    { label: "Products", path: "/products" },
    { label: "Quality", path: "/quality" },
    { label: "Contact Us", path: "/contact" },
];

export const IMAGES = {
    hero: "/images/tubular.jpg",
    machinery: "/images/home-1.webp",
    components: "/images/handlebars-cycle.jpg",
    flanges: "/images/hub-cycle.jpg",
    factory: "/images/home-2.jpg",
    welding: "/images/home-2.jpg",
    handlebars: "/images/handlebars-cycle.jpg",
    hub: "/images/hub-cycle.jpg",
    nozzle: "/images/fuel-filler-tube.webp",
    shockCylinder: "/images/shock-cylinder.jpg",
    shockAbsorber: "/images/shock-absorber.jpg",
    fork: "/images/suspension-fork.webp",
    jbend: "/images/tubular.jpg",
};

export const PILLARS = [
    {
        num: "01",
        title: "Innovation",
        text: "Driving continuous improvement through engineering, technology and research — so every generation of our components is better than the last.",
    },
    {
        num: "02",
        title: "Precision",
        text: "Manufacturing components with accuracy, consistency and technical expertise, measured in microns and proven in the field.",
    },
    {
        num: "03",
        title: "Quality",
        text: "\u201CSuccess Through Quality\u201D — our commitment to every customer and every component that leaves our facility.",
    },
];

export const TIMELINE = [
    {
        year: "2007",
        title: "Super Finishers Founded",
        text: "Mr. Rajeev Gupta establishes Super Finishers to serve the industry with high-quality precision tubular components.",
    },
    {
        year: "2013",
        title: "Cycle Parts Division Established",
        text: "After successful growth in precision tubular components for the shock absorber industry, the company expands into cycle parts manufacturing.",
    },
    {
        year: "Today",
        title: "Engineering the Future",
        text: "Continuing to innovate, invest in technology and serve demanding industries across India and beyond.",
    },
];

export const CAPABILITIES = [
    {
        num: "01",
        title: "Precision Tubular Components",
        text: "High-tolerance tubular components for shock absorbers and automotive applications — cut, formed, machined and finished to exact specification.",
    },
    {
        num: "02",
        title: "Automotive Components",
        text: "Precision-engineered parts for the automotive sector, built for demanding performance and long service life.",
    },
    {
        num: "03",
        title: "Cycle Parts",
        text: "Dedicated Cycle Parts Division manufacturing components at scale for leading bicycle manufacturers.",
    },
    {
        num: "04",
        title: "Custom Manufacturing Solutions",
        text: "From drawing to delivery — custom mass-manufacturing programs developed with our R&D and engineering teams.",
    },
];

export const INFRASTRUCTURE = [
    {
        title: "Sophisticated Machinery",
        text: "A modern shop floor equipped with advanced machines and technology for precision tube processing, machining and finishing.",
    },
    {
        title: "Production Capabilities",
        text: "Dedicated production lines built for consistent, high-volume mass manufacturing without compromising tolerance.",
    },
    {
        title: "Research & Development",
        text: "An in-house R&D team driving product development, process innovation and continuous engineering improvement.",
    },
    {
        title: "Quality Management",
        text: "A dedicated quality function with inspection and testing embedded at every stage of production.",
    },
];

export const CORE_VALUES = [
    { num: "01", title: "Innovation and Excellence", text: "We pursue better methods, better machines and better components — relentlessly." },
    { num: "02", title: "Customer Focus", text: "Every decision starts with the customer's requirement and ends with their satisfaction." },
    { num: "03", title: "Development of Our People", text: "We invest in the skills and growth of the people who build our products." },
    { num: "04", title: "Relationships and Human Dignity", text: "Long-term partnerships built on respect — with customers, suppliers and our own team." },
];

export const PRODUCTS = [
    {
        num: "01",
        title: "Precision Tubular Components",
        tag: "Shock Absorber Industry",
        text: "High-precision tubes and tubular assemblies engineered for shock absorber manufacturers — tight tolerances, superior surface finish, consistent metallurgy.",
        items: ["Shock absorber cylinders & tubes", "Precision cut & formed tubes", "Tubular sub-assemblies"],
        image: "shockCylinder",
    },
    {
        num: "02",
        title: "Shock Absorber Components",
        tag: "Suspension & Damping",
        text: "Complete tubular bodies and assemblies for shock absorbers — manufactured, finished and validated for demanding suspension applications.",
        items: ["Shock absorber bodies & cylinders", "Damper tube assemblies", "Finished struts & dampers"],
        image: "shockAbsorber",
        contain: true,
    },
    {
        num: "03",
        title: "Automotive Components",
        tag: "Automotive OEM & Tier-1",
        text: "Machined, bent and fabricated tubular components for automotive applications, manufactured to drawing and validated through our quality management system.",
        items: ["Fuel filler tube assemblies", "Bent & fabricated tube assemblies", "Custom automotive components"],
        image: "nozzle",
    },
    {
        num: "04",
        title: "Cycle Parts",
        tag: "Cycle Parts Division — Est. 2013",
        text: "High-volume cycle components produced on dedicated lines, serving leading bicycle manufacturers with reliability and scale.",
        items: ["Wheel hubs", "Handlebar & stem parts", "Custom cycle components"],
        image: "hub",
    },
    {
        num: "05",
        title: "Cycle Suspension & Rigid Forks",
        tag: "Cycle Parts Division",
        text: "Suspension and rigid fork assemblies with precision-formed steerer and stanchion tubes — engineered for strength, finish and ride quality.",
        items: ["Suspension fork assemblies", "Rigid forks", "Steerer & stanchion tubes"],
        image: "fork",
        contain: true,
    },
    {
        num: "06",
        title: "Custom Manufacturing Solutions",
        tag: "Built to Your Specification",
        text: "Have a drawing or a requirement? Our R&D and production teams develop custom mass-manufacturing programs end to end.",
        items: ["Development from drawing", "Prototyping & validation", "Scaled mass production"],
        image: "jbend",
    },
];

export const QUALITY_PROCESS = [
    { step: "01", title: "Incoming Material Inspection", text: "High-quality raw materials verified before entering production." },
    { step: "02", title: "In-Process Controls", text: "Dimensional and process checks at every manufacturing stage." },
    { step: "03", title: "Final Inspection & Testing", text: "Finished components validated against specification before dispatch." },
    { step: "04", title: "Continuous Improvement", text: "Data-driven review loops that keep raising the standard." },
];

export const INDUSTRIES = [
    { num: "01", title: "Shock Absorbers & Suspension", text: "Precision tubular components trusted by leading suspension manufacturers." },
    { num: "02", title: "Automotive", text: "Components for OEM and Tier-1 automotive programs." },
    { num: "03", title: "Bicycles & Two-Wheelers", text: "High-volume cycle parts from our dedicated division." },
    { num: "04", title: "Railways", text: "Components serving railway division requirements." },
    { num: "05", title: "Industrial Tools & Agro", text: "Parts for hand tools, agro equipment and industrial applications." },
    { num: "06", title: "Construction & Material Handling", text: "Components for heavy equipment and material handling machinery." },
];

export const CLIENTS = [
    { name: "HERO MOTORS", location: "Noida" },
    { name: "Escorts Limited", location: "Railway Division" },
    { name: "GROZ TOOLS", location: "" },
    { name: "IMPERIAL", location: "Faridabad" },
    { name: "SANDHAR", location: "" },
    { name: "INDO AUTOTECH PVT LTD.", location: "Faridabad" },
    { name: "DAICHI TOOL", location: "AGRO Group Company" },
    { name: "TECUMSEH", location: "Faridabad" },
    { name: "MANITOU (TEREX)", location: "Noida" },
    { name: "SKH", location: "Sila Gurgaon" },
    { name: "CHAMPION", location: "Faridabad" },
];

export const CLIENT_LOGOS = [
    { name: "Hero Cycles", src: "/logos/orig-hero.png" },
    { name: "Escorts Limited", src: "/logos/orig-escorts.png" },
    { name: "GROZ Tools", src: "/logos/orig-groz.png" },
    { name: "Imperial Auto", src: "/logos/orig-imperial.png" },
    { name: "Sandhar", src: "/logos/orig-sandhar.png" },
    { name: "Indo Autotech Limited", src: "/logos/orig-indo.png" },
    { name: "Champion Components", src: "/logos/orig-champion.png" },
    { name: "Tecumseh", src: "/logos/orig-tecumseh.png" },
    { name: "Badve Engineering Group", src: "/logos/orig-badve.png" },
    { name: "Giesecke & Devrient", src: "/logos/orig-giesecke.png" },
];

export const INDUSTRY_OPTIONS = [
    "Shock Absorbers / Automotive",
    "Bicycles & Two-Wheelers",
    "Railways",
    "Industrial Tools & Agro",
    "Construction & Material Handling",
    "Other",
];

export const CONTACT_INFO = {
    address: "P.No. 9 & 20, Choudhary Rishal Singh Ind. Complex, Jeevan Nagar Part-1, Gounchi, Ballabgarh, Faridabad, India",
    email: "info@thesuperfinishers.com",
};
